import { render, staticRenderFns } from "./CriarCampanha2.vue?vue&type=template&id=48b097db"
import script from "./CriarCampanha2.vue?vue&type=script&lang=js"
export * from "./CriarCampanha2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports